var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./riskdetails-gen2auto.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b9c6de1c\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./riskdetails-gen2auto.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports
